<template>
    <div v-if="loading" class="info">{{ $t('common.loading') }}</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else class="detail">
      <h3>{{ service.name }}</h3>
      <p>{{ $t('randevu.services.detail.duration_label') }} <strong>{{ service.duration }} {{ $t('randevu.services.detail.duration_unit') }}</strong></p>
      <p>{{ $t('randevu.services.detail.price_label') }} <strong>{{ service.price }} {{ currency(service.currency_id) }}</strong></p>
      <p>{{ $t('randevu.services.detail.description_label') }}</p>
      <p>{{ service.description || '-' }}</p>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import { useI18n } from "vue-i18n";
  import axios from "axios";
  
  export default {
    props: { serviceId: Number },
    setup(props) {
      const { t } = useI18n();
      const service = ref({});
      const loading = ref(false);
      const error   = ref(null);
      const currency = id => (id === 1 ? "₺" : id === 2 ? "$" : id === 3 ? "€" : "");
  
      const fetch = async () => {
        loading.value = true;
        error.value = null;
        try {
          const { data } = await axios.get(`/promo/user/my-services/${props.serviceId}`);
          service.value = data;
        } catch {
          error.value = t("randevu.services.detail.fetch_error");
        } finally {
          loading.value = false;
        }
      };
  
      onMounted(fetch);
      return { service, loading, error, currency };
    }
  };
  </script>
  
  <style scoped>
  .detail { display: flex; flex-direction: column; gap: 8px; }
  .info  { margin-top: 12px; }
  .error { margin-top: 12px; color: #f44336; }
  </style>
  